import { render, staticRenderFns } from "./nebikiPriceInfo.vue?vue&type=template&id=75eb1c84&"
import script from "./nebikiPriceInfo.vue?vue&type=script&lang=js&"
export * from "./nebikiPriceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports